export const DUE_FROM_PRIOR_TASK_ID = 3;
const DUE_FROM_LEAD_OPENED_ID = 1;
const DUE_FROM_STAGE_ENTERED_ID = 4;

const DUE_FROM_PRIOR_TASK_NAME = 'after the prior task is completed';
const DUE_FROM_LEAD_OPENED_NAME = 'after the lead is opened';
const DUE_FROM_STAGE_ENTERED_NAME = 'after the stage is entered';

export const getHumanReadableDueFrom = (dueFrom?: number | null): string => {
    switch (dueFrom) {
        case DUE_FROM_PRIOR_TASK_ID:
            return DUE_FROM_PRIOR_TASK_NAME;
        case DUE_FROM_LEAD_OPENED_ID:
            return DUE_FROM_LEAD_OPENED_NAME;
        case DUE_FROM_STAGE_ENTERED_ID:
            return DUE_FROM_STAGE_ENTERED_NAME;
        default:
            return '';
    }
};

export const dueFromArray = [
    {
        id: DUE_FROM_PRIOR_TASK_ID,
        value: DUE_FROM_PRIOR_TASK_NAME,
    },
    {
        id: DUE_FROM_LEAD_OPENED_ID,
        value: DUE_FROM_LEAD_OPENED_NAME,
    },
    {
        id: DUE_FROM_STAGE_ENTERED_ID,
        value: DUE_FROM_STAGE_ENTERED_NAME,
    },
] as const;
